/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_AppointmentDetailDTO } from '../models/Routemize_DTOs_AppointmentDetailDTO';
import type { Routemize_DTOs_AppointmentDTO } from '../models/Routemize_DTOs_AppointmentDTO';
import type { Routemize_DTOs_AppointmentDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_AppointmentDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_AppointmentListItem_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_AppointmentListItem_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_AppointmentTimelineResponse } from '../models/Routemize_DTOs_AppointmentTimelineResponse';
import type { Routemize_DTOs_Availability_AssigneeWorkWindowsDto } from '../models/Routemize_DTOs_Availability_AssigneeWorkWindowsDto';
import type { Routemize_DTOs_Availability_TeamMemberAvailabilityDto } from '../models/Routemize_DTOs_Availability_TeamMemberAvailabilityDto';
import type { Routemize_DTOs_Availability_TeamMemberAvailabilityRequestDto } from '../models/Routemize_DTOs_Availability_TeamMemberAvailabilityRequestDto';
import type { Routemize_DTOs_BookingPreviewDTO } from '../models/Routemize_DTOs_BookingPreviewDTO';
import type { Routemize_DTOs_CreateAppointmentDTO } from '../models/Routemize_DTOs_CreateAppointmentDTO';
import type { Routemize_DTOs_CreateStopAppointmentDTO } from '../models/Routemize_DTOs_CreateStopAppointmentDTO';
import type { Routemize_DTOs_RescheduleLinkInfoDTO } from '../models/Routemize_DTOs_RescheduleLinkInfoDTO';
import type { Routemize_DTOs_SearchParameters_AppointmentSearchFilter_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_SearchParameters_AppointmentSearchFilter_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1 } from '../models/Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1';
import type { Routemize_DTOs_SendRescheduleLinkInput } from '../models/Routemize_DTOs_SendRescheduleLinkInput';
import type { Routemize_DTOs_SendRescheduleLinkResultDTO } from '../models/Routemize_DTOs_SendRescheduleLinkResultDTO';
import type { Routemize_DTOs_SwapAppointmentsDTO } from '../models/Routemize_DTOs_SwapAppointmentsDTO';
import type { Routemize_DTOs_SwapAppointmentsResultDTO } from '../models/Routemize_DTOs_SwapAppointmentsResultDTO';
import type { Routemize_DTOs_UpdateAppointmentDTO } from '../models/Routemize_DTOs_UpdateAppointmentDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AppointmentService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_AppointmentDTO OK
     * @throws ApiError
     */
    public static postApiAppAppointmentCreate(
        requestBody?: Routemize_DTOs_CreateAppointmentDTO,
    ): CancelablePromise<Routemize_DTOs_AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/appointment/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppAppointmentDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/appointment/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_AppointmentDTO OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_AppointmentDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/getList',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_AppointmentDTO OK
     * @throws ApiError
     */
    public static putApiAppAppointmentUpdate(
        requestBody?: Routemize_DTOs_UpdateAppointmentDTO,
    ): CancelablePromise<Routemize_DTOs_AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/appointment/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_AppointmentDetailDTO OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetAppointmentDetail(
        id: string,
    ): CancelablePromise<Routemize_DTOs_AppointmentDetailDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/getAppointmentDetail/{Id}',
            path: {
                'Id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_AppointmentListItem_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static postApiAppAppointmentSearch(
        requestBody?: Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/appointment/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestId
     * @param selectedSlotId
     * @returns Routemize_DTOs_BookingPreviewDTO OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetBookingPreview(
        requestId?: string,
        selectedSlotId?: string,
    ): CancelablePromise<Routemize_DTOs_BookingPreviewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/getBookingPreview',
            query: {
                'requestId': requestId,
                'selectedSlotId': selectedSlotId,
            },
        });
    }
    /**
     * @param userId
     * @param startLocation
     * @param startLatitude
     * @param startLongitude
     * @param date
     * @param lunchAddress
     * @param lunchLatitude
     * @param lunchLongitude
     * @param lunchStartTime
     * @param lunchEndTime
     * @returns Routemize_DTOs_AppointmentTimelineResponse OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetUserTimeline(
        userId?: string,
        startLocation?: string,
        startLatitude?: number,
        startLongitude?: number,
        date?: string,
        lunchAddress?: string,
        lunchLatitude?: number,
        lunchLongitude?: number,
        lunchStartTime?: string,
        lunchEndTime?: string,
    ): CancelablePromise<Routemize_DTOs_AppointmentTimelineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/getUserTimeline',
            query: {
                'UserId': userId,
                'StartLocation': startLocation,
                'StartLatitude': startLatitude,
                'StartLongitude': startLongitude,
                'Date': date,
                'LunchAddress': lunchAddress,
                'LunchLatitude': lunchLatitude,
                'LunchLongitude': lunchLongitude,
                'LunchStartTime': lunchStartTime,
                'LunchEndTime': lunchEndTime,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_AppointmentDTO OK
     * @throws ApiError
     */
    public static postApiAppAppointmentCreateStop(
        requestBody?: Routemize_DTOs_CreateStopAppointmentDTO,
    ): CancelablePromise<Routemize_DTOs_AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/appointment/createStop',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SwapAppointmentsResultDTO OK
     * @throws ApiError
     */
    public static postApiAppAppointmentSwap(
        requestBody?: Routemize_DTOs_SwapAppointmentsDTO,
    ): CancelablePromise<Routemize_DTOs_SwapAppointmentsResultDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/appointment/swap',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param appointmentId
     * @returns Routemize_DTOs_RescheduleLinkInfoDTO OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetRescheduleLinkInfo(
        appointmentId: string,
    ): CancelablePromise<Routemize_DTOs_RescheduleLinkInfoDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/getRescheduleLinkInfo/{appointmentId}',
            path: {
                'appointmentId': appointmentId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SendRescheduleLinkResultDTO OK
     * @throws ApiError
     */
    public static postApiAppAppointmentSendRescheduleLink(
        requestBody?: Routemize_DTOs_SendRescheduleLinkInput,
    ): CancelablePromise<Routemize_DTOs_SendRescheduleLinkResultDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/appointment/sendRescheduleLink',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Availability_TeamMemberAvailabilityDto OK
     * @throws ApiError
     */
    public static postApiAppAppointmentGetTeamMemberAvailability(
        requestBody?: Routemize_DTOs_Availability_TeamMemberAvailabilityRequestDto,
    ): CancelablePromise<Array<Routemize_DTOs_Availability_TeamMemberAvailabilityDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/appointment/getTeamMemberAvailability',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @param date
     * @returns Routemize_DTOs_Availability_AssigneeWorkWindowsDto OK
     * @throws ApiError
     */
    public static getApiAppAppointmentGetAssigneeWorkWindows(
        userId?: string,
        date?: string,
    ): CancelablePromise<Routemize_DTOs_Availability_AssigneeWorkWindowsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appointment/getAssigneeWorkWindows',
            query: {
                'UserId': userId,
                'Date': date,
            },
        });
    }
}
